const SavedTranscriptTypes = {
  FETCH_TRANSCRIPTS_REQUEST: 'FETCH_TRANSCRIPTS_REQUEST',
  FETCH_TRANSCRIPTS_SUCCESS: 'FETCH_TRANSCRIPTS_SUCCESS',
  FETCH_TRANSCRIPTS_FAILURE: 'FETCH_TRANSCRIPTS_FAILURE',
  SET_HAS_MORE_TRANSCRIPTS: 'SET_HAS_MORE_TRANSCRIPTS',
  DELETE_TRANSCRIPT_REQUEST: 'DELETE_TRANSCRIPT_REQUEST',
  DELETE_TRANSCRIPT_SUCCESS: 'DELETE_TRANSCRIPT_SUCCESS',
  DELETE_TRANSCRIPT_FAILURE: 'DELETE_TRANSCRIPT_FAILURE',
  SET_SELECTED_TRANSCRIPT_ID: 'SET_SELECTED_TRANSCRIPT_ID',
  RESET_TRANSCRIPTS: 'RESET_TRANSCRIPTS',
  UPDATE_TRANSCRIPT_TITLE_REQUEST: 'UPDATE_TRANSCRIPT_TITLE_REQUEST',
  UPDATE_TRANSCRIPT_TITLE_SUCCESS: 'UPDATE_TRANSCRIPT_TITLE_SUCCESS',
  UPDATE_TRANSCRIPT_TITLE_FAILURE: 'UPDATE_TRANSCRIPT_TITLE_FAILURE',
  ADD_NEW_TRANSCRIPT: 'ADD_NEW_TRANSCRIPT',
};

export default SavedTranscriptTypes;
